var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "mku-breadcrumb-item" }, [
    _vm.to
      ? _c(
          "a",
          {
            staticClass: "mku-breadcrumb-item__link",
            attrs: { href: _vm.to, target: _vm.target },
            on: { click: _vm.handleClick }
          },
          [_vm._t("default")],
          2
        )
      : _c(
          "span",
          { staticClass: "mku-breadcrumb-item__span" },
          [_vm._t("default")],
          2
        ),
    _vm._v(" "),
    _c(
      "span",
      { staticClass: "mku-breadcrumb-item__separator" },
      [_c("separator")],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }